module.exports = __webpack_public_path__ + "static/media/pca_plot.9705d0e8.png";